import { useState } from "@wordpress/element";
import { Menu } from '@headlessui/react';

export type Item = {
  title: string,
  href: string,
  active: boolean,
  icon: null | undefined | { open: string, close: string }
  children: Item[]
};

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}

function MenuItem(props: { item: Item }) {
  let initialOpen = false;
  if (props.item.children.length > 0) {
    props.item.children.forEach(child => {
      if (child.active) {
        initialOpen = true;
      }
    })
  }

  let [isOpen, setIsOpen] = useState(initialOpen);

  const click = (e: { preventDefault: Function }, item: Item) => {
    if (item.children.length == 0) {
      return true;
    }

    e.preventDefault();

    setIsOpen(!isOpen);

    return false;
  };

  const label = (item: Item, open?: boolean) => {
    if (item.children.length > 0) {

      if (!item.icon) {
        return <>{item.title}</>
      }

      return (
        <>
          {item.title}
          {open
            ? <i className={item.icon.close}></i>
            : <i className={item.icon.open}></i>
          }
        </>
      )
    }
    return (
      <>{item.title}</>
    )
  };

  const link = (item: Item, active: boolean) => {
    let cl = "";
    if (item.active) {
      cl += " font-bold";
    }

    const onClick = (item: Item) => {
      return (e: any) => {
        if (item.href == "#") {
          e.preventDefault();
          return false;
        }

        return true;
      }
    };

    return (
      <a
        href={item.href}
        onClick={onClick(item)}
        className={classNames(
          active ? "bg-primary-200 text-gray-900" : "text-gray-700",
          "block px-4 py-2 text-sm",
          cl
        )}
      >
        {label(item, isOpen)}
      </a>
    )
  };

  return (
    <>
      {props.item.children.length > 0
        ?
          <div onClick={(e: { preventDefault: Function }) => click(e, props.item) }>
            <Menu.Item disabled>
              {({ active }) => (
                link(props.item, active)
              )}
            </Menu.Item>
          </div>
        :
          <Menu.Item>
            {({ active }) => (
              link(props.item, active)
            )}
          </Menu.Item>
      }
      {isOpen && props.item.children.map((child, key) => (
        <Menu.Item key={key}>
          {({ active }) => (
            <div className="pl-4">{link(child, active)}</div>
          )}
        </Menu.Item>
      ))}
    </>
  )
}

export function ModalNavigation(props: { button: string, items: Item[] }) {
  const [open, setOpen] = useState(true);

  const createMarkup = (html) => {
    return {
      __html: html
    }
  };

  return (
    <Menu as="div">
      <Menu.Button className="focus:outline-none">
        {props.button &&
          <div onClick={() => setOpen(!open)}>
            <div dangerouslySetInnerHTML={createMarkup(props.button)} />
          </div>
        }
      </Menu.Button>

      {open &&
      <Menu.Items static
        className="z-30 origin-top-right absolute right-6 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
      >
        <div className="py-1">
          {props.items.map((item, key) => (
            <MenuItem item={item} key={key}></MenuItem>
          ))}
        </div>
      </Menu.Items>
      }
    </Menu>
  )
}

